var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 4.557 C 23.101 4.955 22.148 5.217 21.172 5.332 C 22.201 4.717 22.97 3.749 23.337 2.608 C 22.37 3.182 21.313 3.586 20.21 3.803 C 19.279 2.809 17.978 2.246 16.616 2.248 C 13.437 2.248 11.101 5.214 11.819 8.293 C 7.86 8.095 4.171 6.225 1.671 3.149 C 0.364 5.399 1.031 8.277 3.194 9.723 C 2.413 9.698 1.648 9.487 0.965 9.107 C 0.911 11.388 2.546 13.522 4.914 13.997 C 4.189 14.194 3.428 14.223 2.69 14.081 C 3.335 16.087 5.183 17.461 7.29 17.5 C 5.226 19.119 2.604 19.853 0 19.54 C 2.252 20.987 4.872 21.754 7.548 21.752 C 16.69 21.752 21.855 14.031 21.543 7.106 C 22.507 6.409 23.339 5.546 24 4.557 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.d87f2b9d.svg";
export { ForwardRef as ReactComponent };